import { render } from "./PaymentTransactionDetails.vue?vue&type=template&id=15d7e644&scoped=true"
import script from "./PaymentTransactionDetails.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionDetails.vue?vue&type=script&lang=js"

import "./PaymentTransactionDetails.vue?vue&type=style&index=0&id=15d7e644&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d7e644"]])

export default __exports__